import { z } from 'zod'

import { TranslationLocale } from '../../types/enums/translation/translation.enum'

/**
 * Schema for a `Translation[]` form field.
 *
 * - Each entry must have a valid locale and a non-empty value.
 * - Locales passed in `requiredLocales` must be present with a non-empty value.
 */
export const createTranslationsSchema = (requiredLocales: TranslationLocale[] = []) =>
  z
    .array(
      z.object({
        locale: z.nativeEnum(TranslationLocale),
        value: z.string().trim().min(1)
      })
    )
    // Blocks submit; the per-locale error is surfaced under each input by TranslationsInput
    .refine((translations) =>
      requiredLocales.every((locale) =>
        translations.some((t) => t.locale === locale && t.value.trim().length > 0)
      )
    )
